<template>
  <nav class="navbar navbar-expand-lg bg-transparent top-header">
    <div class="container-fluid">
      <div class="dropdown">
        <a
          class="navbar-brand mRight"
          id="triggerId"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          @click="isOpen = !isOpen"
        >
          <img src="images/logo.png" alt="" class="logo" />
        </a>
        <div
          class="dropdown-menu"
          :class="isOpen ? 'show' : ''"
          aria-labelledby="triggerId"
        >
          <router-link class="dropdown-item" @click="isOpen = false" to="/"
            >Dashboard</router-link
          >
          <router-link
            class="dropdown-item"
            @click="isOpen = false"
            to="/inventory"
            >Inventory</router-link
          >
          <router-link
            class="dropdown-item"
            @click="isOpen = false"
            to="/marketplace"
            >Marketplace</router-link
          >
          <router-link
            class="dropdown-item"
            @click="isOpen = false"
            to="/staking"
            >Shipyard</router-link
          >
          <router-link
            class="dropdown-item"
            @click="isOpen = false"
            to="/continent"
            >Discover</router-link
          >
          <router-link
            class="dropdown-item"
            @click="isOpen = false"
            to="/leaderBoard"
            >Leaderboard</router-link
          >
          <router-link
            class="dropdown-item"
            @click="isOpen = false"
            to="/battle"
            >Battle</router-link
          >
          <router-link
            class="dropdown-item"
            @click="isOpen = false"
            to="/attack"
            >Attack</router-link
          >
          <router-link
            class="dropdown-item"
            @click="isOpen = false"
            to="/waiting"
            >Result</router-link
          >
          <router-link class="dropdown-item" @click="isOpen = false" to="/login"
            >Logout</router-link
          >
        </div>
      </div>
      <div class="nav-brand">
        <div class="progress-wrapper">
          <img src="/lostsailor/images/food-stock.png" class="mx-2" alt="" />
          <div class="progress-cont">
            {{ foodCount }}
          </div>
          <div class="progress-title left-0 mx-3">
            <span>Food Stock</span>
          </div>
        </div>
      </div>

      <button
        class="navbar-toggler d-lg-none"
        type="button"
        data-toggle="collapse"
        data-target="#collapsibleNavId"
        aria-label="Toggle navigation"
        @click="menuOpen = !menuOpen"
      >
        <span class="navbar-icon">
          <i class="fas fa-bars"></i>
        </span>
      </button>
      <div
        class="collapse navbar-collapse"
        :class="menuOpen ? 'show' : ''"
        id="collapsibleNavId"
      >
        <div class="d-flex nav-menu">
          <a class="navbar-brand" href="#">
            <div class="progress-wrapper">
              <img src="/lostsailor/images/ship-wheel.png" class="wheel-img" alt="" />
              <div class="progress-cont">
                <div class="progress__bar" v-if="userXP > 0"></div>
                <div class="progress__bar" v-if="userXP > 10"></div>
                <div class="progress__bar" v-if="userXP > 20"></div>
                <div class="progress__bar" v-if="userXP > 30"></div>
                <div class="progress__bar" v-if="userXP > 40"></div>
                <div class="progress__bar" v-if="userXP > 50"></div>
                <div class="progress__bar" v-if="userXP > 60"></div>
                <div class="progress__bar" v-if="userXP > 70"></div>
                <div class="progress__bar" v-if="userXP > 80"></div>
                <div class="progress__bar" v-if="userXP > 90"></div>
              </div>
              <div class="progress-title">
                <span>Experience level ({{ userLevel }})</span>
              </div>
            </div>
          </a>
          <div class="navbar-brand" href="#">
            <div class="progress-wrapper">
              <img src="/lostsailor/images/coin.png" class="coin-img" alt="" />
              <div class="progress-cont">
                {{ balance }}
              </div>
              <div class="progress-title">
                <span>Balance</span>
              </div>
            </div>
          </div>
          <div class="navbar-brand dropdown">
            <div class="user-wrapper">
              <img src="/lostsailor/images/profile-img.png" alt="" />
              <a
                href="javascript:void(0)"
                class="dp-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                @click="menuOpenDrop = !menuOpenDrop"
              >
                {{ authentication.user_name }}
              </a>
            </div>
            <ul
              class="dropdown-menu"
              :class="menuOpenDrop ? 'show' : ''"
              aria-labelledby="dropdownMenuButton1"
            >
              <li>
                <a class="dropdown-item" href="/login">Logout</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="sideBar">
        <side-bar />
      </div>
    </div>
  </nav>
</template>
<script>
// import Dropdown from "@/views/Dropdown";
import SideBar from "./SideBar.vue";
import ApiService from "../services";
import { reactive } from "vue";
import { mapGetters } from "vuex";
export default {
  name: "Navbar",
  components: {
    SideBar,
  },
  computed: {
    ...mapGetters(["balance"]),
  },
  data() {
    return {
      foodCount: 0,
      userXP: 0,
      userLevel: 1,
      info: null,
      dropdownItem: [
        {
          title: "Logout",
          link: "#",
        },
        {
          title: "als",
          link: "#",
        },
      ],
      menuOpen: false,
      menuOpenDrop: false,
      isOpen: false,
    };
  },
  mounted() {
    ApiService.getBalance((res) =>
      this.$store.commit("addBalance", res.data[0])
    );
    ApiService.callApi(
      `collection_name=lostsailorsl&schema_name=foods`,
      (response) => {
        let res = response["data"];
        if (res["success"]) {
          this.info = res["data"];
          this.info.map(async (nft) => {
            await ApiService.getItemUsage(
              nft.asset_id,
              (row) => {
                if (row) {
                  let usage = row[0].usage;
                  let useleft = Number(nft.data.use) - Number(usage);
                  this.foodCount += Number(useleft);
                } else {
                  if (nft.data.totaluse) {
                    let useleft =
                      Number(nft.data.use) - Number(nft.data.totaluse);
                    this.foodCount += Number(useleft);
                  } else {
                    this.foodCount += Number(nft.data.use);
                  }
                }
              },
              null
            );
          });
        }
      }
    );
    ApiService.getTableSingle(
      "playersxp",
      localStorage.getItem("wax_user"),
      async (result) => {
        if (result.rows.length > 0) {
          const row = result.rows.find(
            (x) => x.account === localStorage.getItem("wax_user")
          );
          if (row !== undefined) {
            this.userLevel = row.level;
            const divider = this.getLevelRange();
            this.userXP = ((row.xp / divider) * 100).toFixed(1);
            this.$store.commit("addLevel", this.userLevel);
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  },
  methods: {
    getLevelRange() {
      if (this.userLevel == 1 || this.userLevel == 0) {
        return 100;
      }
      if (this.userLevel == 2) {
        return 400;
      }
      if (this.userLevel == 3) {
        return 900;
      }
      if (this.userLevel == 4) {
        return 1600;
      }
      if (this.userLevel == 5) {
        return 2500;
      }
      if (this.userLevel == 6) {
        return 3600;
      }
      if (this.userLevel == 7) {
        return 4900;
      }
      if (this.userLevel == 8) {
        return 6400;
      }
      if (this.userLevel == 9) {
        return 8100;
      }
      if (this.userLevel == 10) {
        return 10000;
      }
      if (this.userLevel == 11) {
        return 12100;
      }
      if (this.userLevel == 12) {
        return 14400;
      }
      if (this.userLevel == 13) {
        return 16900;
      }
      if (this.userLevel == 14) {
        return 19600;
      }
      if (this.userLevel == 15) {
        return 22500;
      }
      if (this.userLevel == 16) {
        return 25600;
      }
      if (this.userLevel == 17) {
        return 28900;
      }
      if (this.userLevel == 18) {
        return 32400;
      }
      if (this.userLevel == 19) {
        return 36100;
      }
      if (this.userLevel == 20) {
        return 72000;
      }
    },
  },
  setup() {
    const authentication = reactive({
      user_name: localStorage.getItem("wax_user"),
    });
    return {
      authentication,
    };
  },
};
</script>
<style scoped>
.left-0 {
  left: 40px !important;
}
.dp-toggle {
  color: #fff;
  font-size: 14px;
}

.mRight {
  margin-right: 0 !important;
}
.navbar {
  padding: 10px 50px;
}
</style>